var _rect, _defs, _desc, _title, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 470,
    height: 506,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a2d9fa",
    stopOpacity: 0.99609375,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#068fe0",
    stopOpacity: 0.99609375,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_2",
    x1: 0,
    y1: 0.996874988079071
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a2d9fa",
    stopOpacity: 0.99609375,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#068fe0",
    stopOpacity: 0.99609375,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_3",
    x1: 0,
    y1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a2d9fa",
    stopOpacity: 0.99609375,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#068fe0",
    stopOpacity: 0.99609375,
    offset: 1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "url(#svg_3)",
    fillRule: "evenodd",
    className: "selected",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    fill: "url(#svg_3)",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194,0 C42.66666700000002,124 -20,244 6,360 C18.273549000000003,408.247746 57.25053600000001,423.456995 89,436 C136.738926,454.859832 179.113225,436.159331 218,440 C299,448 358,495 470,506 C470,401.333333 470,232.666667 470,0 L194,0 z",
    id: "Path",
    fill: "url(#svg_3)",
    fillOpacity: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/vector1.4d41ff6f98cab824123d3c528ef44e4c.svg";
export { ForwardRef as ReactComponent };